/**
 * Created by chenchen on 2015/9/18.
 */
"use strict";
angular.module('pieceMgr.singleDoc',["util.smallIcon","pieceMgr.singleDocdir"]);